import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Formik } from "formik";
import { useDispatch } from "react-redux";

// components
import DataSafetyMessage from "../../components/Messages/DataSafetyMessage";
import ContactMessage from "../../components/Messages/ContactMessage";
import InfoMessage from "../../components/Messages/InfoMessage";
import MainHeader from "../../components/Header/MainHeader";
import Loader from "../../components/Loader/Loader";

// methods
import ServicesAPI from "../../services/services";
import { enterPanValidation } from "../../validations/user.validation";
import { addPanVerifyData } from "../../redux/slices/registerSlice";
import PanExistModal from "../../components/Modal/PanExistModal";
import Swal from "sweetalert2";
import { CustomButton } from "../../components";
import { googleEvent_LOJ011 } from "../../lib/google-analytics-loan-journey-events";
import {
  googleEvent_LOJ012,
  googleEvent_LOJ013,
  googleEvent_LOJ014,
  googleEvent_LOJ015,
} from "../../lib/google-analytics";

export default function EnterPan() {
  const [openPanModal, setOpenPanModal] = useState({ bottom: false, mobileNo: "" });
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const { panVerification } = new ServicesAPI();

  useEffect(() => {
    googleEvent_LOJ011();
  }, []);

  return (
    <div className="wrapper auto-height">
      <Formik
        initialValues={{ pan: "", pinCode: "" }}
        validationSchema={enterPanValidation}
        onSubmit={(values, { setSubmitting }) => {
          setSubmitting(true);

          setTimeout(async () => {
            const res = await panVerification(values.pan, values.pinCode);

            if (res.statusCode === 200) {
              googleEvent_LOJ015(values.pan);
              dispatch(addPanVerifyData(res.data));
              navigate("/pan-verify");
            } else if (res.statusCode === 400) {
              const data = res?.data?.mobileNo;
              if (data) {
                setOpenPanModal({ ...openPanModal, bottom: true, mobileNo: data });
              } else {
                Swal.fire({
                  icon: "error",
                  text: res.message,
                  timer: 3000,
                });
              }
            } else {
              Swal.fire({
                icon: "error",
                text: res.message,
                timer: 3000,
              });
            }

            setSubmitting(false);
          }, 500);
        }}
      >
        {({ errors, values, touched, isSubmitting, handleChange, handleBlur, handleSubmit, setFieldValue }) => (
          <form onSubmit={handleSubmit} style={{ height: "100%" }}>
            <div className="vertical-column-layout">
              <div className="vertical-column-top">
                <MainHeader title="Pan Verification" />
                {/* <p className="label">Enter your PAN</p> */}
                {/* <div className="sub-label mb-2">
                  Please enter your <strong>PAN</strong> number
                </div> */}

                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter your PAN"
                    name="pan"
                    value={values.pan}
                    onChange={(e) => {
                      const pan = e.target.value.toUpperCase();
                      setFieldValue("pan", pan);

                      if (pan.length === 10) {
                        googleEvent_LOJ012(pan);
                      }

                      if (pan.length === 0) {
                        googleEvent_LOJ013();
                      }
                    }}
                    // onInput={(e) => {
                    //   setFieldValue("pan", e.target.value);
                    // }}
                    onBlur={(e) => {
                      setFieldValue("pan", e.target.value.trim());
                    }}
                    autoComplete="off"
                    maxLength={10}
                    style={{ textTransform: "uppercase" }}
                  />

                  {touched.pan && errors.pan ? (
                    <>
                      <div className="error-msg">{errors.pan}</div>
                      {googleEvent_LOJ014()}
                    </>
                  ) : null}
                </div>

                <InfoMessage message="Your PAN number should be like this: RRRRR0000R" />

                <br />

                {/* <ContactMessage /> */}
                {/* <p className="label mt-2">Enter Pin Code</p> */}
                {/* <div className="sub-label mb-2">Please enter your Pincode</div> */}

                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Pin Code"
                    name="pinCode"
                    value={values.pinCode}
                    onChange={(e) => {
                      const input = e.target.value;
                      if (/^\d{0,6}$/.test(input)) {
                        setFieldValue("pinCode", input);
                      }
                    }}
                    autoComplete="off"
                  />

                  {touched.pinCode && errors.pinCode ? <div className="error-msg">{errors.pinCode}</div> : null}
                </div>
                <InfoMessage message="Used to verify address  eligibility for this loan" />
              </div>

              <div className="vertical-column-bottom">
                <DataSafetyMessage />

                <CustomButton text="Next" type="submit" />
              </div>
            </div>
          </form>
        )}
      </Formik>

      <PanExistModal openPanModal={openPanModal} setOpenPanModal={setOpenPanModal} />
    </div>
  );
}
